export default __webpack_public_path__ + "static/reaction-devel-0de603dc5d2a0bf506dbfd1d6ba91f84.png";